(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  class HofEyeLogo {
    constructor(element) {
      this.element = element;
      this.stage = element.querySelector('.hof-eye-logo__stage');
      this.pupil = element.querySelector('.hof-eye-logo__pupil');

      if (!this.stage || !this.pupil) return;

      this.currentX = 0;
      this.currentY = 0;
      this.targetX = 0;
      this.targetY = 0;

      this.maxMovement = 10;
      this.ease = 0.12;

      this.onPointerMove = this.onPointerMove.bind(this);
      this.animate = this.animate.bind(this);

      this.init();
    }

    init() {
      if (reduceMotion.matches) return;

      /* Nur für Maus / Trackpad aktivieren */
      if (!window.matchMedia('(pointer: fine)').matches) return;

      window.addEventListener('pointermove', this.onPointerMove, {
        passive: true
      });

      this.animate();
    }

    onPointerMove(event) {
      const rect = this.stage.getBoundingClientRect();

      const centerX = rect.left + rect.width / 2;
      const centerY = rect.top + rect.height / 2;

      const deltaX = event.clientX - centerX;
      const deltaY = event.clientY - centerY;

      const distance = Math.hypot(deltaX, deltaY);

      if (distance === 0) {
        this.targetX = 0;
        this.targetY = 0;
        return;
      }

      const normalizedX = deltaX / distance;
      const normalizedY = deltaY / distance;

      const influence = Math.min(distance / 250, 1);

      this.targetX = normalizedX * this.maxMovement * influence;
      this.targetY = normalizedY * this.maxMovement * influence;
    }

    animate() {
      this.currentX += (this.targetX - this.currentX) * this.ease;
      this.currentY += (this.targetY - this.currentY) * this.ease;

      this.pupil.style.transform =
        `translate3d(${this.currentX}px, ${this.currentY}px, 0)`;

      requestAnimationFrame(this.animate);
    }
  }

  const initEyes = () => {
    document.querySelectorAll('.hof-eye-logo').forEach((eye) => {
      if (!eye.dataset.hofEyeInitialized) {
        eye.dataset.hofEyeInitialized = 'true';
        new HofEyeLogo(eye);
      }
    });
  };

  document.addEventListener('DOMContentLoaded', initEyes);
  document.addEventListener('shopify:section:load', initEyes);
})();
